export default __webpack_public_path__ + "static/media/home-interior-design-about-img02.81320690.jpg";